import { H3 } from '@h3/types';
import { View } from '../view';
import { Control } from '../control';

export namespace Plugin {
    export enum ConnectionInvokeType {
        /** 普通 */
        Normal = 1,
        /** 代码调用 */
        CodeEditor = 2,
    }

    export enum PluginStatus {
        /** 未安装 */
        UnInstall = 0,
        /** 已安装 */
        Install = 1,
    }

    export enum ConnectionConfigStatus {
        /** 禁用 */
        Disable = 0,
        /** 正常 */
        Normal = 1,
        /** 异常 */
        Exception = 2,
    }

    export enum SmsTemplateStatus {
        /** 正常 */
        Normal = 1,
        /** 禁用 */
        Disable = 2,
    }

    export enum PluginsCodeEnum {
        /** 第三方连接 */
        Connection = 'connection',
        /** 钉钉OCR */
        DingTalkOcr = 'ocr',
        /** 邮件 */
        Email = 'email',
        /** 钉钉云盘 */
        DingtalkDrive = 'dingtalkdrive',
        /** 批量扫码 */
        BatchScan = 'batchscan',
        /** 钉钉通知 */
        DingTalkNotice = 'dingtalknotice',
        /** 消息发送至群聊 */
        RobotNotification = 'robotnotification',
        /** 人脸识别 */
        FaceRecognition = 'facerecognition',
        /** 电子签章 */
        Esign = 'esign',
        /** 电子签章通用版 */
        EsignCommon = 'commonesign',
        /** 钉钉连接器 */
        DingTalkConnector = 'dingtalkconnector',
        /** 短信 */
        Sms = 'sms',
        /** 在线支付 */
        Payment = 'payment',
        /** 钉钉考勤 */
        DingTalkAttendance = 'dingtalkattendance',
        /** 企微家校通讯录 */
        WxworkSchool = 'wxworkschool',
        /** 日程 */
        Schedule = 'schedule',
    }

    export enum EsignType {
        /** 通用版 */
        CommonEsign = 'commonesign',
        /** 钉签 */
        DingtalkEsign = 'esign',
    }

    export enum EsignFlowStatus {
        /** 未指定 */
        Unspecified = -9,
        /** 找不到E签宝任务 */
        NoFound = -2,
        /** 预提交(接口调用后尚未在e签宝发起) */
        PreCommit = -1,
        /** 草稿 */
        Draft = 0,
        /** 签署中 */
        Running = 1,
        /** 完成 */
        Finish = 2,
        /** 撤销 */
        Revoke = 3,
        /** 终止 */
        Abort = 4,
        /** 过期 */
        Expired = 5,
        /** 删除 */
        Delete = 6,
        /** 拒签 */
        Refuse = 7,
    }

    export enum WxworkchatType {
        /** 所有 */
        All = -1,
        /** 图片 */
        Image = 2,
        /** 视频 */
        Video = 7,
        /** 语音 */
        Voice = 6,
        /** 链接 */
        Url = 4,
        /** 附件 */
        Attachment = 8,
        /** 红包 */
        Redpacket = 13,
        /** 小程序 */
        MiniProgram = 5,
    }

    export enum WxworkUserType {
        /** 员工 */
        Employee = 1,
        /** 客户 */
        Customer = 2,
        /** 群聊 */
        Group = 3,
    }

    export interface OpenDataFrameInstance {
        createOpenDataFrame(praram: any);
    }

    export interface searchParams {
        cursor: string;
        limit: number;
    }

    export interface WxworkChatItem {
        msgid: string;
        secretKey: string;
        userId: string;
        isSent: boolean;
        date: string;
    }

    export const EsignFlowStatusText = {
        [EsignFlowStatus.Unspecified]: '未指定',
        [EsignFlowStatus.NoFound]: '未找到',
        [EsignFlowStatus.PreCommit]: '待发起',
        [EsignFlowStatus.Draft]: '草稿',
        [EsignFlowStatus.Running]: '签署中',
        [EsignFlowStatus.Finish]: '完成',
        [EsignFlowStatus.Revoke]: '撤销',
        [EsignFlowStatus.Abort]: '终止',
        [EsignFlowStatus.Expired]: '过期',
        [EsignFlowStatus.Delete]: '删除',
        [EsignFlowStatus.Refuse]: '拒签',
    };

    export enum EsignSignerStatus {
        Waiting = 0,
        Signing = 1,
        Complete = 2,
        WaitForApproval = 3,
        Refuse = 4,
    }

    /** 机器人类型 */
    export enum RobotType {
        DingTalk = 1,
        WeChat = 2,
        FeiShu = 3,
    }

    export const EsignSignerStatusText = {
        [EsignSignerStatus.Waiting]: '待签',
        [EsignSignerStatus.Signing]: '未签',
        [EsignSignerStatus.Complete]: '已签',
        [EsignSignerStatus.WaitForApproval]: '待审批',
        [EsignSignerStatus.Refuse]: '拒签',
    };

    export enum ConnectionPosition {
        /** query */
        Query = 1,
        /** header */
        Header = 2,
        /** body */
        Body = 3,
        /** response */
        Response = 4,
    }

    export enum ProviderType {
        /** 氚云 */
        ChuanYun = 0,
        /** 阿里云 */
        ALiYun = 1,
        /** 腾讯云 */
        TengXunYun = 2,
    }

    /** 插件 */
    export interface PluginsModel {
        objectId: string;
        name: string;
        code: PluginsCodeEnum;
        state: PluginStatus;
    }

    /** 连接 */
    export interface ConnectionConfigModel {
        objectId: string;
        title: string;
        engineCode: string;
        invokeType: ConnectionInvokeType;
        status: ConnectionConfigStatus;
        intro: string;
    }

    export interface ConnectionDetailField {
        objectId: string;
        bizSource: number;
        position: ConnectionPosition;
        title: string;
        dataType: number;
        fieldValue: string;
        sort: number;
        isToken: boolean;
    }

    /** 连接详情 */
    export interface ConnectionDetailModel {
        authenticationId: string;
        /** 同title */
        code: string;
        contenttype: string;
        /** 企业编码 */
        engineCode: string;
        /** 字段 */
        fields: ConnectionDetailField[];
        /** 调用类型 */
        invokeType: ConnectionInvokeType;
        /** id */
        objectId?: string;
        /** 请求方法 */
        requestMethod: string;
        /** 相应方式 */
        responseType: string;
        /** 状态 */
        status: ConnectionConfigStatus;
        /** 名称 */
        title: string;
        /** 地址 */
        url: string;
    }

    /** 氚云短信模板 */
    export interface ChuanYunSmsTemplateModel {
        /** id */
        objectId: string;
        subject: string;
        sign: string;
        /** 状态 */
        status: SmsTemplateStatus;
        /** 是否是系统模板 */
        isSystem: boolean;
    }

    /** 第三方短信模板模型 */
    export interface ThirdpartySmsTemplateModel {
        /** 模板编码 */
        code: string;
        /** 模板标题 */
        name: string;
        /** 模板内容 */
        content: string;
    }

    /** 通用短信模板模型 */
    export interface CommonSmsTemplateModel {
        /** 模板编码 */
        templateId: string;
        /** 签名 */
        sign: string | undefined;
        /** 模板标题 */
        title: string;
        /** 模板内容 */
        content: string;
        /** 是否是系统模板 */
        isSystem: boolean;
    }

    /** 短信服务商 */
    export interface ServiceProviderModel {
        key: ProviderType;
        label: string;
        image: string;
    }

    /** 短信签名 */
    export interface SmsSignModel {
        value: string;
        label: string;
    }

    /** 第三方短信模板模型 */
    export interface SmsConfigModel {
        objectId: string;
        providerType: ProviderType;
        authInfo: Record<string, string>;
        status: SmsTemplateStatus;
        createdTime: string;
        modifiedTime: string;
    }

    export interface IMappingParams {
        TempId: string | undefined;
        Template: string | undefined;
        TempParam: Array<{ Type: '1' | '2'; Value?: string; Name: string; Error?: boolean }>;
        UserPhones: Array<{ Type: H3.Control.ControlDesigner.ButtonSmsUserPhoneType; Value?: string }>;
        /** 前端用到 */
        Phones?: string[];
        Signature: string | undefined;
        ProviderCode: ProviderType;
    }

    export interface PluginInvokeModel {
        key: string;
        value: string | View.Runtime.Response.TLoadDataFile[];
        isChild?: boolean;
    }

    export interface WxworkChatSendUser {
        id: string;
        name: string;
        sessionObjectId: string;
    }

    export interface WxworkChatReceivedUser {
        id: string;
        name: string;
        avatar: string;
        lastMsgType: string;
        lastMsgSendTime: string;
        sessionObjectId: string;
        corpName: string;
        isWeChatCustomer: boolean;
    }

    export interface WxworkChatMessage {
        msgId: string;
        encryptedSecretKey: string;
        msgType: string;
        sendTime: string;
        senderId: string;
        senderName: string;
        senderLastName: string;
        isWeChatCustomer: boolean;
        isSent?: boolean;
    }

    export interface EsignUserInfo {
        accountType: 'DING_USER' | 'OUTER_USER';
        account: string;
        accountName: string;
        orgName: string;
        userId: string;
        signRequirements?: string;
        ccRequirements?: string;
    }

    /** 发送机器人消息类型 */
    export enum RobotNotificationMessageType {
        /** 文本 */
        Text = 1,
        Link = 3,
    }

    export namespace Request {
        export interface EsignProcessStartUrlModel {
            files: Array<{ fileId: string; fileName: string; uploadUrl: string }>;
            participants: Array<EsignUserInfo>;
            ccs: Array<EsignUserInfo>;
            initiatorUserId: string;
            bizObjectId: string;
            schemaCode: string;
            dataField: string;
            redirectUrl: string;
            autoStart?: boolean;
            sourceInfo?: Record<string, unknown>;
            taskName?: string;
        }

        export interface EsignAuthInfoModel {
            engineCode: string;
            /** 用户Id */
            userId?: string;
            /** 是否是组织认证，为true不用传unitId */
            isOrgAuth: boolean;
        }

        /** 获取个人/组织认证地址 */
        export interface EsignAuthUrlModel {
            engineCode: string;
            /** 用户Id */
            userId?: string;
            companyName?: string;
            isOrgAuth: boolean;
        }

        /** 获取印章管理地址 */
        export interface EsignSealUrlModel {
            engineCode: string;
            userId: string;
        }

        /** 获取签署流程详情 */
        export interface EsignSignFlowDetailModel {
            engineCode: string;
            userId: string;
            /** 签署任务Id */
            taskId: string;
        }

        /** 获取个人签署地址 */
        export interface EsignSignUrlModel {
            engineCode: string;
            userId: string;
            /** 签署任务Id */
            taskId: string;
        }

        export interface EsignDocsModel {
            taskId: string;
            bizObjectId: string;
            schemaCode: string;
            dataField: string;
        }

        export interface SendRobotNotificationModel {
            robotType: RobotType;
            Webhook: string;
            EncryKey?: string;
            isAtAll: boolean;
            mobiles?: string[];
            /** 消息类型 1:文本 3:链接 */
            messageType?: RobotNotificationMessageType;
            textContent?: string;
            link?: {
                title: string;
                text: string;
                messageUrl: string;
            };
        }

        export interface VerifyRobotNotificationModel {
            webhook: string;
            secretKey: string;
            botType: RobotType;
        }
    }

    export namespace Response {
        export interface IFaceRecognitionPersonGroupInfo {
            groupId: string;
            groupName: string;
            /** 扩展字段 */
            groupExDescriptions: string[];
            description: string[];
        }

        export interface EsignAuthInfoModel {
            /** 实名状态 */
            realNameStatus: boolean;
            /** 授权状态 */
            authorizeStatus: boolean;
            /** 用户psnId */
            eSignId: string;
            companyName: string;
        }

        export interface EsignSignFlowDetailModel {
            status: string;
            participants: Array<{
                name: string;
                status: string;
            }>;
        }
    }

    export namespace Next {
        // 插件状态
        export enum PluginState {
            PrePublish = 1, // 预发布
            UnderReview = 2, // 审核中
            Published = 3, // 已发布
        }
        // 插件身份验证信息
        export interface IPluginAuth {
            key: string; // 参数key
            name: string; // 参数名称
            type: Control.BizDataType; // 参数数据类型
            required: boolean; // 是否必填，用于开启时校验
            value?: string; // 实际值，插件开启时设置
            tip?: string; // 属性值名称的描述
        }

        export namespace UI {
            // 控件属性设置元数据
            export interface IControlProperty {
                key: string; // 属性key
                name: string; // 属性名称
                type: Control.BizDataType; // 属性的数据类型，普通类型或者JSON， 区分简单类型和复合类型，设计时、运行时都需要用到属性
                code: string; // 记录源代码，属性存取器，简化逻辑，用一个复合JSON对象来存储，不细分，自定义组件，记录源代码（UI）
                required: boolean; // 是否必填，用于属性设置时校验
                tip?: string; // 属性值名称的描述
                errorMessage?: string; // 校验不通过时的提示，用于属性设置时校验
            }

            // 设计态组件
            export interface IDesignControl {
                properties: IControlProperty[]; // 设计时控件属性
                isDefault: boolean; // 定义自定义控件是否是系统默认呈现，还是自定义设计态UI
                code: string; // 设计态展现，记录源代码
            }

            // 运行时组件
            export interface IRuntimeControl {
                pcCode: string; // pc端自定义组件源代码
                pcViewCode: string;
                mobileCode: string; // 移动端自定义组件源代码，为空时说明该端未实现
                mobileViewCode: string;
            }
        }
        // 插件控件定义
        export interface IPluginControl {
            id?: string; // 不再需要，和插件编码一致
            code?: string; // 不再需要，和插件编码一致
            name?: string; // 不再需要，和插件编码一致
            icon?: string; // 不再需要，和插件编码一致
            createSchema: boolean;
            dataType: Control.BizDataType; // 控件存储的数据类型
            definition: string; // 控件定义， 代码实现，记录源代码
            design: UI.IDesignControl; // 设计态UI
            runtime: UI.IRuntimeControl; // 运行态UI
        }

        // 前端扩展参数定义
        export interface IPluginExtensionParam {
            name: string;
            key: string;
            type: Control.BizDataType;
        }

        // 后端服务
        export interface IPluginService {
            // name: string; // 服务名称
            // key: string; // 服务编码
            code: string; // 服务源代码
        }

        // 前端扩展
        export interface IPluginExtension {
            name: string; // 函数显示名称
            key: string; // 函数名
            inParams: IPluginExtensionParam[]; // 入参
            outParams: IPluginExtensionParam[]; // 出参
            code: string; // 函数体
        }

        // 插件回调
        export interface IPluginCallback {
            encryptionType: number; // TODO
            encryption: any; // TODO
        }

        //
        export interface IPluginTemplateInfo {
            objectId?: string; // 系统id
            code: string; // 插件编码
            name: string; // 插件名称
            icon: string; // 图标图标地址，上传到oss，记录oss地址
            description: string; // 描述说明
            helpLinkUrl: string; // 帮助链接地址
            version: string; // 版本信息
            auth?: IPluginAuth[]; // 身份验证信息，可以为空
            ui?: IPluginControl | null; // UI控件，可以为空
            services?: IPluginService | null; // 后端服务，可以为空，目前只能有1个
            extension?: IPluginExtension[]; // 前端扩展，可以为空
            hook: string; // 钩子函数，记录源代码
            // 插件发布管理相关信息
            author: string; // 作者信息（预留，企业纬度、个人纬度）
            publishedTime: string; // 发布日期
            modifiedTime: string; // 更新日期
            status: PluginState; // 是否发布（生效），未生效的记录每个插件只有一条
            changeLog?: string; // 更新说明
            // 分类信息，便于后续插件市场的分类管理
            category?: string; // 插件所属分类
            callback?: IPluginCallback;
            engineCode?: string;
        }

        // 插件实例，绑定引擎
        export interface IPluginInstance {
            engineCode?: string; // 企业编码
            id: string; // 系统id
            code: string; // 插件编码
            name: string; // 插件名称
            icon: string; // 图标图标地址，上传到oss，记录oss地址
            description: string; // 描述说明
            helpLinkUrl: string; // 帮助链接地址
            version: string; // 版本信息
            auth?: IPluginAuth[]; // 身份验证信息，可以为空，身份验证信息开启时需要赋值
            ui?: IPluginControl[]; // UI控件，可以为空
            services?: IPluginService[]; // 后端服务，可以为空
            extension?: IPluginExtension[]; // 前端扩展，可以为空
            isLocal?: boolean; // 是否本地插件
            hook: string; // 钩子函数，记录源代码
            status: number; // 启用/禁用状态
            // 插件发布管理相关信息
            author: string; // 作者信息（预留）
            publishedTime: string; // 发布日期
        }
    }
}
